export const CARDS_BLOCK_07 = {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#FAFAFA",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#333333",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 0,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "#333333",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      }
    },
    {
      "type": "text",
      "id": 1746531362022,
      "elIndex": 1,
      "text": "[[role]]",
      "location": "B",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "margin": "10px 0px 0px 0px",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "color": "#a3a3a3",
        "font-weight": "500"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "0.875rem",
        "line-height": "1.25rem",
        "margin": "1px 0px 0px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746547347956,
      "elIndex": 2,
      "text": "[[status ]]",
      "location": "C",
      "params": [
        {
          "value": "status",
          "label": "status "
        }
      ],
      "styleProps": {
        "color": "#808080",
        "font-weight": "700",
        "background-color": "#fafafa",
        "padding": "4px 8px 4px 8px",
        "border-radius": "0.75rem",
        "font-size": "1rem",
        "line-height": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "0.875rem",
        "line-height": "1.25rem"
      },
      "stylePropsMob": {
        "font-size": "0.875rem",
        "line-height": "1.25rem"
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 3
    },
    "layout": "l3",
    "cardstyleProps": {
      "padding": "80px 10px 10px 10px"
    },
    "cardstylePropsMob": {
      "padding": "40px 0px 10px 0px"
    },
    "cardstylePropsTab": {
      "padding": "60px 10px 10px 10px"
    }
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1746548010110
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1746548089648,
  "afterIndex": 6,
  "blockId": 1746548089648,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('')",
        "border-radius": "1.5rem",
        "padding": "0px 0px 0px 0px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff",
        "box-shadow": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"
      },
      "stylePropsTab": {
        "border-radius": "1rem"
      },
      "stylePropsMob": {
        "border-radius": "0.75rem"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "#ffffff",
        "margin": "0px 0px 0px 0px",
        "border-radius": "0.75rem",
        "padding": "240px 26px 20px 26px",
        "box-shadow": "",
        "alignItems": "center",
        "justify-content": "center",
        "flex-direction": "column",
        "display": "flex",
        "width": "100%",
        "text-align": "center",
        "background-image": "url('[[img]]')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover"
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "30px 30px 30px 30px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "",
        "width": "65%",
        "alignItems": "",
        "text-align": "left"
      },
      "stylePropsTab": {
        "padding": "20px 20px 20px 20px"
      },
      "stylePropsMob": {
        "padding": "14px 14px 14px 14px"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "35%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center"
      },
      "innerDiv": {
        "styleProps": {
          "width": "auto",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "center"
        }
      }
    }
  ]
}